import Vue from "vue";
import zn from "./zn";
import en from "./en";
import tw from "./tw";
// 引入elementui的国际语言
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import twLocale from "element-ui/lib/locale/lang/zh-TW";
import locale from "element-ui/lib/locale";

import VueI18n from "vue-i18n";

Vue.use(VueI18n); // 全局注册国际化包
// console.log("znBean",znBean);
// console.log("enBean",enBean);
// console.log("twBean",twBean);

/* 
znBean,enBean,twBean 在index.html页面请求静态文件获取
document.write(`<script src="http://10.105.113.219:8080/static/lang/lang.js?time=${new Date().getTime()}"><\/script>`);
*/

// 准备翻译的语言环境信息
const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "zn", // 初始化中文
  messages: {
    // zn: { ...zn, ...zhLocale },
    // en: { ...en, ...enLocale },
    // tw: { ...tw, ...twLocale }
    zn: { ...znBean, ...zhLocale },
    en: { ...enBean, ...enLocale },
    tw: { ...twBean, ...twLocale }
  },
  silentTranslationWarn: true // 去除国际化警告
});

//实现element插件的多语言切换
locale.i18n((key, value) => i18n.t(key, value));
export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js